// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1769060777682
      var cssReload = require("G:/pinmingproject/suppervision-manager-ui-huangshi/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  